import { Action } from "../actions/types"
import { ExpenseMasterType, ExpenseMasterActionList } from "../actions/expenseMasterActions"

const initialValue: Array<ExpenseMasterType> = []

const expenseMasterReducer = (state: Array<ExpenseMasterType> = initialValue, action: Action) => {
    switch (action.type) {

        case ExpenseMasterActionList.ADD_EXPENSE_MASTER:
            return [
                ...state,
                action.data,
            ]

        case ExpenseMasterActionList.UPDATE_EXPENSE_MASTER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case ExpenseMasterActionList.FETCH_EXPENSE_MASTER:
            return action.data

        case ExpenseMasterActionList.DELETE_EXPENSE_MASTER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default expenseMasterReducer